const _filteredAnnouncements = (s) => {
  const filter = s.root.contentSection
  const all = s.root.announcements || []
  if (!filter || filter === 'All posts') return all
  const lc = filter.toLowerCase()
  return all.filter((a) => (a.tag || '').toLowerCase() === lc)
}

export const announcements = {
  extends: 'ContentPage',
  metadata: { title: 'Announcements / Symbols Workspace' },
  eyebrow: 'The blog',
  title: 'Announcements',
  sections: [
    { label: 'All posts' },
    { label: 'Product' },
    { label: 'People' },
    { label: 'Ops' }
  ],

  PageBody: {
    flow: 'y',
    gap: 'D',
    flex: '1',
    minWidth: '0',

    Grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(440px, 1fr))',
      gap: 'C',
      childExtends: 'AnnouncementCard',
      childrenAs: 'state',
      children: (el, s) => _filteredAnnouncements(s)
    },

    AnnouncementDetailModal: {}
  }
}
